import React from 'react';

import configureStore from './Components/invoice/configureStore';
import { HashRouter as Router } from 'react-router-dom';

import Routes from './Routes';
import { Provider } from 'react-redux';

const store = configureStore();

function App() {
  console.log(process.env.REACT_APP_STAGE);
  return (
    <Provider store={store}>
      <Router>
        <Routes />
      </Router>
    </Provider>
  );
}

export default App;
